import style from './MerchantPageView.css';
import Title from '../shared/Typography/Title';
import Button from '../shared/Button/Button';
import Alert from '../shared/Alert/Alert';
import useTranslation from '../../localization/i18n.context';
import TextField from '../shared/TextField/TextField';
import { useState } from 'preact/hooks';
import MerchantService from '../../services/merchant.service';
import NavigationUtils from '../../utils/navigation.utils';
import { EnterAmountType } from '../../routes/EnterAmountPage/EnterAmountProvider';
import { MerchantStatusErrorMessage } from './MerchantStatusErrorMessage';
import CardStatus from '../../constants/card.status';

export default function MerchantPageView({
  settings,
  className = '',
  organizationCode = '',
}) {
  const topUpDisabled =
    !settings.activationDate || settings.status === CardStatus.LOCKED;

  const alertMessage = !topUpDisabled
    ? 'Your Merchant ID is unique and will be linked to your account. If you need to change it later, please contact {card name}.'
    : topUpDisabled && settings.status === CardStatus.LOCKED
      ? 'Your card is locked. Unlock it to top up'
      : 'You need to have an active card to be able to top up';
  const alertType = topUpDisabled ? Alert.Type.WARNING : Alert.Type.INFO;

  const { t, getOrganization } = useTranslation();
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [merchantId, setMerchantId] = useState('');
  const isButtonEnabled = merchantId !== '';

  function cleanError() {
    setHasError(false);
    setErrorMessage(null);
  }

  function onContinueButtonClick() {
    MerchantService.validateMerchant(merchantId)
      .then(response => {
        NavigationUtils.navigate(NavigationUtils.Routes.ENTER_AMOUNT, false, {
          type: EnterAmountType.POS,
          merchantId: response.data.merchantId,
          organizationCode: organizationCode,
          source: NavigationUtils.Sources.WALLET,
        });
      })
      .catch(err => {
        setHasError(true);
        let errorMessage = MerchantStatusErrorMessage(t)[err.body.code].message;
        setErrorMessage(errorMessage ?? t('Something went wrong'));
      });
  }

  return (
    <main className={`${style.container} ${className}`}>
      <Title text={t('Enter your Merchant ID')} className={style.title} />
      <Alert
        type={alertType}
        className={style.alert}
        message={t(alertMessage, {
          '{card name}': getOrganization(organizationCode),
        })}
        hasIcon
      />

      <TextField
        label={t('Merchant ID')}
        placeholder="123456789"
        inputMode="numeric"
        pattern="\d*"
        hasError={hasError}
        helperText={errorMessage}
        onInput={e => {
          cleanError();
          setMerchantId(e.target.value);
        }}
        disabled={topUpDisabled}
      />
      <div className="fixed-cta">
        <Button
          fullWidth
          onClick={onContinueButtonClick}
          disabled={!isButtonEnabled}
        >
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
